var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenuCelular(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Menu-celular",
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.2,
    height: 25,
    viewBox: "0 0 27.2 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1022",
    "data-name": "Caminho 1022",
    d: "M0,66.083A2.015,2.015,0,0,1,1.943,64H25.257a2.088,2.088,0,0,1,0,4.167H1.943A2.015,2.015,0,0,1,0,66.083ZM0,76.5a2.015,2.015,0,0,1,1.943-2.083H25.257a2.088,2.088,0,0,1,0,4.167H1.943A2.015,2.015,0,0,1,0,76.5ZM27.2,86.917A2.015,2.015,0,0,1,25.257,89H1.943a2.088,2.088,0,0,1,0-4.167H25.257A2.015,2.015,0,0,1,27.2,86.917Z",
    transform: "translate(0 -64)",
    fill: "#e8c6ad"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuCelular);
export default __webpack_public_path__ + "static/media/Menu-celular.29780555befba67714df6ee16c820872.svg";
export { ForwardRef as ReactComponent };